"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_hook_form_1 = require("react-hook-form");
const react_number_format_1 = __importDefault(require("react-number-format"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const string_utils_1 = require("@/common/string_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ defaultValues, productIndex, minStock, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { register, control, formState: { errors }, } = (0, react_hook_form_1.useForm)({ mode: 'onChange', defaultValues });
    const dispatch = (0, react_redux_1.useDispatch)();
    const onFinishInput = (field, value) => {
        dispatch((0, roomCreateStore_1.setProductInfo)({ productIndex, field, value }));
    };
    const onNameBlur = (nameInput) => {
        onFinishInput('name', nameInput);
    };
    const onOriginPriceBlur = (priceInput) => {
        onFinishInput('origin_price', priceInput);
    };
    const { field: { onChange: onStockChange, value: stockValue }, } = (0, react_hook_form_1.useController)({
        name: 'stock',
        control,
        rules: { min: { value: minStock, message: t('minStock개 이상 입력해주세요', { minStock }) } },
    });
    const onStockBlur = (stockInput) => {
        onFinishInput('stock', stockInput);
    };
    const onPurchaseLimitBlur = (purchaseLimitInput) => {
        onFinishInput('purchase_limit', purchaseLimitInput);
    };
    const isEdit = (0, react_redux_1.useSelector)((state) => state.isEdit);
    const isFeeFree = (0, react_redux_1.useSelector)((state) => state.roomData.fee_free);
    const isFreeFormData = (0, react_redux_1.useSelector)((state) => state.productData)[productIndex]
        .isFreeFormData;
    const promiseEditCheck = (0, react_1.useRef)(false);
    const isLess7299 = 7299 > Number(defaultValues.origin_price) && Number(defaultValues.origin_price) > 0;
    const checkPromiseEditModalOnClick = () => {
        if (isFreeFormData && !promiseEditCheck.current) {
            promiseEditCheck.current = true;
            dispatch((0, roomCreateStore_1.setOpenPromiseEditModal)(true));
        }
    };
    const onFreeFormPriceChange = () => {
        if (isFreeFormData) {
            dispatch((0, roomCreateStore_1.invalidateFreeFormData)(productIndex));
        }
    };
    const roomType = (0, react_redux_1.useSelector)((state) => state.roomData.room_type);
    const isRegularForm = roomType === '굿즈' || roomType === '서포트';
    const isPayform = isRegularForm && !isFeeFree;
    const isPromiseForm = isRegularForm && isFeeFree;
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const priceRequired = isPayform || isDemandSurvey ? false : t('상품 가격을 입력해주세요');
    const priceMinimumRule = isPayform || isDemandSurvey ? undefined : { value: 1, message: t('0원은 입력할 수 없어요') };
    return ((0, jsx_runtime_1.jsxs)(UpdateDiv, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "product_info_title_input" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('작품 이름') })), (0, jsx_runtime_1.jsx)("input", Object.assign({ className: "product_info_input", autoComplete: "off", maxLength: 25, placeholder: t('작품 이름을 입력해주세요') }, register('name', {
                        required: `${t('작품 이름을 입력해주세요')}.`,
                        pattern: { value: /^[^,]+$/, message: `${t('콤마 (,)를 제거해주세요')}.` },
                    }), { onBlur: e => onNameBlur(e.target.value.replace(/,/g, '')) })), errors.name && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 error-dark" }, { children: errors.name.message }))] }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "product_info_title_input" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: isDemandSurvey ? t('가격') : `${t('원가')}(${t('판매가')})` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ onClick: checkPromiseEditModalOnClick }, { children: (0, jsx_runtime_1.jsx)(components_1.PriceCalculator, { name: "origin_price", control: control, defaultValue: defaultValues.origin_price, onBlurFunc: onOriginPriceBlur, isFeeFree: isFeeFree, isFreeFormData: isFreeFormData, onFreeFormPriceChange: onFreeFormPriceChange, required: priceRequired, minimumRule: priceMinimumRule, isDemandSurvey: isDemandSurvey }) })), errors.origin_price && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 error-dark" }, { children: errors.origin_price.message }))] })), isPromiseForm && !isFreeFormData && isLess7299 && !isEdit && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 gray-80" }, { children: t('페이폼이 더 저렴해요') }))] }))] })), !isDemandSurvey && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "product_info_title_input" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('재고') })), (0, jsx_runtime_1.jsx)(react_number_format_1.default, { className: "product_info_input", allowNegative: false, isAllowed: ({ value }) => Number(value) <= 9999, decimalScale: 0, value: stockValue, onValueChange: e => {
                            onStockChange(e.value);
                        }, thousandSeparator: true, suffix: t('개'), placeholder: `9,999${t('개')}`, autoComplete: "off", pattern: "\\d*", onBlur: (e) => onStockBlur(e.target.value === '' ? '' : (0, string_utils_1.numberOnly)(e.target.value)) }), errors.stock && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 error-dark" }, { children: errors.stock.message }))] }))] }))), !isDemandSurvey && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "product_info_title_input" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('구매개수 제한') })), (0, jsx_runtime_1.jsx)(react_number_format_1.default, { className: "product_info_input", allowNegative: false, isAllowed: ({ value }) => Number(value) <= 9999, decimalScale: 0, thousandSeparator: true, suffix: t('개'), placeholder: `9,999${t('개')}`, autoComplete: "off", pattern: "\\d*", defaultValue: defaultValues.purchase_limit, onBlur: (e) => onPurchaseLimitBlur((0, string_utils_1.numberOnly)(e.target.value)) })] })))] }));
}
exports.default = default_1;
const UpdateDiv = styled_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  .product_info_title_input {
    display: grid;
    grid-template-columns: 0.3fr 0.7fr;
    gap: 4px;
    align-items: center;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.8);
  }
  .product_info_input {
    width: 100%;
    height: 40px;
    padding: 0 13px;
    border: 1px solid var(--gray-10);
    border-radius: 8px;
    color: var(--gray-80);
    :focus {
      border: 1px solid var(--gray-60);
    }
  }
`;
